export default __webpack_public_path__ + "resources/icons/d210-dedd.webp";